
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Der geheime Untersuchungsbericht</h4>
    <p>
  Die Solothurner Regierung lädt zur Pressekonferenz. Sie stellt den Untersuchungsbericht zum Fall William W. wie folgt
  vor: «Die externen Experten attestieren den Behörden ein gutes Zeugnis. Die Untersuchung ergab keine Hinweise auf
  fehlerhaftes Verhalten der Staatsanwaltschaft und des Amtes für Justizvollzug.» Als Beleg schalten die Behörden eine
  Zusammenfassung auf. Den vollständigen, 73-seitigen Bericht hält die Regierung unter Verschluss. Ein Einsichtsgesuch
  der Redaktion Tamedia lehnt sie ab. «Es besteht zwar angesichts der bisherigen Medienberichte ein beträchtliches und
  legitimes Interesse der Öffentlichkeit am Ergebnis der Untersuchung», so die Begründung. Man wolle aber vermeiden, das
  laufende Verfahren gegen William W. zu beeinflussen.
    </p>
    <p>
  Die Redaktion zieht den Entscheid weiter, beharrt auf dem Einsichtsgesuch. Es kommt zur Schlichtungsverhandlung. An
  dieser empfiehlt die Solothurner Datenschutzbeauftragte, dass der Kanton zumindest jene Passagen zugänglich machen
  soll, die nichts mit dem laufenden Verfahren gegen W. zu tun haben. Danach vergehen mehrere Monate, ohne dass der
  Regierungsrat auf diese Empfehlung eingeht.
    </p>
    <Image proportions='4:3' source='Solothurner Regierungsräte und externe Experten bei der Medienkonferenz. (Staatskanzlei Solothurn)' file={require('images/medienkonferenz.jpg')} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;